import { createMutation } from "@steto-care/steto-query";

import { AuthRepository } from "@/io/repository/AuthRepository.ts";

/**
 * Temporary auth logic for transistion
 * TODO REMOVE WHEN LEGACY LOGIN IS REMOVED
 */
export class NewAuthBridge {
  constructor(private readonly authRepository: AuthRepository = new AuthRepository()) {}

  login = async (legacyToken: string) => {
    const newTokens = await this.authRepository.legacyTokenToStetoToken(legacyToken);
    await this.authRepository.setRefreshToken(newTokens.refresh);
    return newTokens.access;
  };

  logout = async () => {
    const refresh = await this.authRepository.getRefreshToken();
    if (refresh) {
      await this.authRepository.revokeRefreshToken(refresh);
    }
    await this.authRepository.deleteTokens();
  };
}

export const newAuthBridge = new NewAuthBridge();

export class AuthQueries {
  constructor(private readonly authRepository: AuthRepository = new AuthRepository()) {}

  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  useRefreshTokens = createMutation("use-refresh-token", async (): Promise<string | null> => {
    const token = await this.authRepository.getRefreshToken();
    if (!token) {
      return null;
    }
    const tokens = await this.authRepository.refreshTokens(token);
    if (!tokens.refresh) {
      return null;
    }
    await this.authRepository.setRefreshToken(tokens.refresh);
    return tokens.access;
  });

  useLogout = createMutation("use-logout", async () => {
    const refresh = await this.authRepository.getRefreshToken();
    if (refresh) {
      await this.authRepository.revokeRefreshToken(refresh);
    }
    await this.authRepository.deleteTokens();
  });

  useTryLegacyLogin = createMutation("use-try-legacy-login", async ({ legacyToken }: { legacyToken: string }) => {
    const newTokens = await this.authRepository.legacyTokenToStetoToken(legacyToken);
    await this.authRepository.setRefreshToken(newTokens.refresh);
    return newTokens.access;
  });
}
